import { Controller } from "@hotwired/stimulus"

// data-controller="crud--upload-simples"
// Substitui o <script> inline de _upload_simples.html.erb
export default class extends Controller {
  static targets = ["input", "btn", "rm", "img", "placeholder", "filename"]

  connect() {
    this.resetAll()
  }

  choose() {
    this.inputTarget.click()
  }

  remove() {
    this.resetAll()
  }

  changed() {
    const input = this.inputTarget
    if (!input.files || !input.files[0]) {
      this.resetAll()
      return
    }

    const file = input.files[0]

    // se for imagem, mostra preview
    if (file.type && file.type.startsWith("image/")) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.showImage(e.target.result)
        this.setFileName(file.name)
      }
      reader.readAsDataURL(file)
    } else {
      // para outros formatos (ex: PDF), mostra apenas o nome sem preview
      this.showPlaceholder()
      this.setFileName(file.name)
      this.rmTarget.style.display = ""
    }
  }

  // --- private ---

  resetAll() {
    this.showPlaceholder()
    this.setFileName("Nenhum arquivo selecionado")
    this.inputTarget.value = ""
  }

  showPlaceholder() {
    this.imgTarget.style.display = "none"
    this.imgTarget.src = ""
    this.placeholderTarget.style.display = ""
    this.rmTarget.style.display = "none"
  }

  showImage(src) {
    this.placeholderTarget.style.display = "none"
    this.imgTarget.src = src
    this.imgTarget.style.display = ""
    this.rmTarget.style.display = ""
  }

  setFileName(name) {
    this.filenameTarget.textContent = name || "Nenhum arquivo selecionado"
  }
}
